import { defineStore } from 'pinia'
import dashboardApi from '@/helpers/dashboardApi'
import { releaseStatusesValidForWorks } from '@/constants'

interface ReleaseFilters {
  page: number,
  perPage: number,
  qcPassed?: boolean,
  publishingAllowed?: boolean,
  typeId: number | null,
  'artists.id': number[],
  'status.id': number[],
}

interface ReleasesStore {
  releases: Release[] | null,
  releasesCount: number,
  selectedRelease: Release | null,
  filters: ReleaseFilters,
}

export const useReleasesStore = defineStore('releases', {
  state: () => ({
    releases: null,
    releasesCount: 0,
    selectedRelease: null,
    filters: {
      page: 1,
      perPage: 12,
      publishingAllowed: true,
      typeId: null,
      'artists.id': [],
      'status.id': releaseStatusesValidForWorks,
    },
  }) as ReleasesStore,

  actions: {
    async getReleases() {
      const { data } = await dashboardApi.get('api/me/releases/music', {
        params: {
          ...this.filters,
        },
      })

      this.releases = data['hydra:member']
      this.releasesCount = data['hydra:totalItems']
    },

    async getRelease(releaseId: number) {
      const { data } = await dashboardApi.get('api/me/releases/music', {
        params: {
          id: releaseId,
        },
      })

      this.selectedRelease = data['hydra:member'][0]
    },
  },
})
